import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { ToolOrderService } from "@services/toolOrder.service";
import { ToastService } from "angular-toastify";
import { ToastApiError } from "@helpers/apiError";

@Component({
	moduleId: module.id,
	selector: "toolOrders",
	styleUrls: ["toolOrders.css"],
	templateUrl: "toolOrders.html"
})
export class ToolOrdersAdminComponent {
	deleteEnabled = false;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "Billet";
	itemUrl = "toolOrders";
	items: any[] = [];
	title: string;

	constructor(private router: Router, private toastService: ToastService, private itemService: ToolOrderService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.headerPrimaryButtons.push({ icon: "fal fa-calendar-alt", method: "goToPlanning", text: "Planning" });
		this.title = `${this.itemType}s`;
		this.deleteRow = this.deleteRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.getItems();
	}

	addNewItem() {
		this.router.navigate(["/admin/toolOrders/create"]);
	}

	deleteRow(e: any) {
		if (confirm("Are you sure you want to delete this tool order?")) {
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						ToastApiError(this.toastService, err);
					}
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`/admin/toolOrders/${e.row.data.id}_edit`]);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAllGrid()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					ToastApiError(this.toastService, err);
				}
			);
	}

	goToPlanning() {
		this.router.navigate(["/admin/toolOrderPlanning"]);
	}

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	viewRow(e: any) {
		this.router.navigate([`/admin/toolOrders/${e.row.data.id}`]);
	}
}
